module.exports = __webpack_public_path__ + "img/cutaway_driving.abe42943.svg";